import React from 'react';
import { StoreModules } from '~/lib/data-contract';
import { ErrorBoundary } from '~/shared/utils/errorBoundary';
import { ErrorFallbackContent } from '../ErrorFallbackContent/ErrorFallbackContent';
import { MapMarker } from '~/features/find-store/components/StoreMap/models';

//Store Details
import StoreTextSpot from '~/features/find-store/components/StoreMap/components/StoreTextSpot';
import StoreDetailSpot from '~/features/find-store/components/StoreMap/components/StoreDetailSpot';
import StoreImageSpot from '~/features/find-store/components/StoreMap/components/StoreImageSpot';
import StoreOpeningHoursSpot from '~/features/find-store/components/StoreMap/components/StoreOpeningHours';

type StoreBlockProps = {
    element: StoreModules;
    index?: number;
    storeList?: MapMarker;
};

export const StoreBlock = ({ storeList, element, index, ...rest }: StoreBlockProps) => {
    return (
        <ErrorBoundary fallback={<ErrorFallbackContent />}>
            {getType({ storeList, element, index, ...rest })}
        </ErrorBoundary>
    );
};

export const getType = ({ storeList, element, ...rest }: StoreBlockProps) => {
    switch (element.type) {
        case 'storeTextSpot':
            return (
                <StoreTextSpot
                    spacingBottom="default"
                    spacingTop="default"
                    {...element}
                    {...rest}
                />
            );

        case 'storeDetailModule':
            return <StoreDetailSpot {...element} storeList={storeList} {...rest} />;

        case 'storeImageSpot':
            return <StoreImageSpot spacingTop="small" {...element} {...rest} />;

        case 'storeOpeningHoursSpot':
            return <StoreOpeningHoursSpot {...element} storeList={storeList} {...rest} />;
        default:
            return null;
    }
};
